import { useMemo } from 'react';
import Decimal from 'decimal.js';
import { Controller, useFormContext } from 'react-hook-form';
import { Column, Divider, Row, TextField, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from "./ServicePriceEditorPopoverBundleContent.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const getServicePriceEditorPopoverBundleContentTID = () => getTestIds();
const ServicePriceEditorPopoverBundleContent = () => {
  const {
    ServicePriceEditorPopoverBundleContentTID
  } = useMemo(() => getServicePriceEditorPopoverBundleContentTID(), []);
  const {
    control,
    watch,
    setValue
  } = useFormContext();
  const includedServices = watch('bundle');
  if (!includedServices || includedServices.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Column, {
      gap: 16,
      "data-testid": ServicePriceEditorPopoverBundleContentTID.Root(),
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "paragraph1",
        weight: "normal",
        children: "Included services:"
      }), /*#__PURE__*/_jsx(Column, {
        gap: 24,
        children: includedServices.map((includedService, index) => {
          const serviceTemplateId = includedService.serviceTemplateId || '';
          return /*#__PURE__*/_jsxs(Row, {
            gap: 16,
            className: styles.includedServiceRow,
            "data-testid": ServicePriceEditorPopoverBundleContentTID.IncludedServiceRow(serviceTemplateId),
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "paragraph2",
              className: styles.includedServiceItem,
              "data-testid": ServicePriceEditorPopoverBundleContentTID.IncludedServiceName(serviceTemplateId),
              children: includedService.name
            }), /*#__PURE__*/_jsx(Controller, {
              control: control,
              name: "bundle.".concat(index, ".rate"),
              rules: {
                validate: value => {
                  if (!value) return 'Rate is required';
                  if (value.toNumber() < 0) return 'Rate must be non-negative';
                  return true;
                }
              },
              render: _ref => {
                var _fieldState$error;
                let {
                  field,
                  fieldState
                } = _ref;
                return /*#__PURE__*/_jsx(TextField, {
                  collapseHelperText: false,
                  testid: ServicePriceEditorPopoverBundleContentTID.IncludedServiceRateInput(serviceTemplateId),
                  className: styles.includedServiceItem,
                  isMoney: true,
                  inputProps: {
                    min: 0
                  },
                  label: "Rate",
                  prefix: "$",
                  value: field.value ? field.value.toNumber() : '',
                  onChange: e => {
                    const newValue = e.currentTarget.value;
                    const asNumber = +newValue;
                    if (asNumber < 0) return;
                    const decimalValue = new Decimal(newValue === '' ? 0 : asNumber);
                    field.onChange(decimalValue);
                    const totalRate = includedServices.reduce((acc, includedService) => acc.plus(includedService.rate), new Decimal(0));
                    setValue('price', totalRate.toString());
                  },
                  error: !!fieldState.error,
                  helperText: (_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message
                });
              }
            })]
          }, serviceTemplateId);
        })
      })]
    })]
  });
};
export default ServicePriceEditorPopoverBundleContent;